<template>
  <div>
  <Header :title="title"/>
    <div class="footer_podat" v-if="karobka && !set">
       <div class="main">
        <div align="center"><button class="btns" @click="dale()">Далее</button></div>
       </div>
    </div>

    <div class="content_podat">
      <div v-for="k in arrkarobka" :key="k.id" class="block_radio">
        <input
          class="custom-radio"
          name="color"
          v-model="karobka"
          type="radio"
          :id="k.id"
          :value="k.id"
          @change="selectkarobka"
        />
        <label :for="k.id">{{k.text}} </label>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/headerpodat'
export default {
   components:{
   Header
   },
  data() {
    return {
      title:"Выберите коробка передач",
      karobka:"",
      txtkarobka:"",
      set:this.$route.params.set,
       arrkarobka: [
        { id: "mexanika",text: "Механика"},
        { id: "avtomat",text: "Автомат"},
        { id: "tiptronik",text: "Типтроник"},
        { id: "variator",text: "Вариатор"},
        { id: "robot",text: "Робот"},
       ],
    };
  },
  methods: {
    selectkarobka() {
        const values = Object.values(this.arrkarobka);
        for (let i = 0; i < values.length; i += 1) {
          if (values[i].id === this.karobka) this.txtkarobka = values[i].text;
        }
        if(this.$route.params.set){
            this.$store.commit("addsetkarobka",this.karobka);
            this.$store.commit("addsetkarobka_text",this.txtkarobka);
            this.$router.go(-1);
        }
        else{
          this.$store.commit("addpodatkarobka",this.karobka);
          this.$store.commit("addpodatkarobka_text",this.txtkarobka);
          this.dale();
        }

    },
    dale() {
      this.$router.push({ name: "privod" });
    },
  },
  computed: {
     getkarobka() {
      return this.$store.getters.getpodatkarobka;
    },
   },
  created() {
     if (!this.$route.params.set) {
       if (!localStorage.getItem("token")) {
       this.$router.go(-1); 
      } 
      } 
  },
  mounted (){
     if(this.getkarobka){
      this.karobka=this.getkarobka;
    }
  }
};
</script>
<style scoped>
.block_radio {
  margin-bottom: 1.4em;
}
.divgorod {
  width: 100%;
  color: #777777;
}
.contentgorod {
  font-size: 20px;
  border-bottom: 1px solid #000000;
  padding: 5px 5px 5px 0px;
}
label {
  font-size: 18px;
  width: 100%;
}
.content_podat {
  padding: 120px 5px 65px 10px;
}
</style>